import * as React from 'react';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { styled } from '@mui/system';
import { Box } from '@mui/material';

const InfoContainer = styled(Box)({
  width: '100%',
});

const NoteTitleLable = styled('div')(({ theme }) => ({
  fontFamily: 'Fjalla One',
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '20px',
  color: '#fff',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    marginBottom: '8px',
  },
}));

const AuthorRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const NoteAuthorLable = styled('span')(({ theme }) => ({
  fontFamily: 'Raleway',
  fontStyle: 'normal',
  fontSize: '16px',
  fontWeight: 400,
  color: '#AB9178',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    lineHeight: '14px',
  },
}));

const NoteLike = styled('span')({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
});

const ThumbUpIcon = styled('span')(({ theme }) => ({
  paddingTop: '5px',
  color: '#AB9178',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '15px',
    height: '15px',
    padding: '0',
    '& svg': {
      width: '14px',
      height: '14px',
    },
  },
}));

const NoteLikeNumbers = styled('span')(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontSize: '16px',
  fontWeight: 600,
  color: '#AB9178',
  [theme.breakpoints.down('sm')]: {
    fontSize: '13px',
    lineHeight: '15px',
    fontWeight: 400,
  },
}));

const NoteCardInfo = (props) => {
  return (
    <InfoContainer>
      <NoteTitleLable>{props.title}</NoteTitleLable>
      <AuthorRow>
        <NoteAuthorLable>{props.author}</NoteAuthorLable>
        <NoteLike>
          <ThumbUpIcon>
            <ThumbUpOffAltIcon />
          </ThumbUpIcon>
          <NoteLikeNumbers>{props.numberLikes}</NoteLikeNumbers>
        </NoteLike>
      </AuthorRow>
    </InfoContainer>
  );
};

export default NoteCardInfo;
